// Locale files for the `shared` messages, loaded at build time and keyed by locale.
// Adding a locale is dropping a `<locale>.json` in beside the others — no code change.
const localeModules = import.meta.glob("./shared/*.json", { eager: true });

const messages = {};
for (const path in localeModules) {
  const locale = path.match(/\.\/shared\/(.+)\.json$/)?.[1];
  if (locale) {
    messages[locale] = localeModules[path].default || localeModules[path];
  }
}

export default messages;
